export default __webpack_public_path__ + "static/logo-a748f4bf60be72ac20c68a3681d111e4.png";